<template>
  <div>
    <v-skeleton-loader
      type="table-thead, table-tbody"
      width="100%"
      :loading="preconditionOrdersHistoryTableLoader"
      boilerplate
    >
      <v-container class="prices-list-table pa-0 fill-height" fluid>
        <v-card width="100%" class="fill-height" color="gray10 pa-5">
          <v-row class="fill-height">
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    class="white--text float-left"
                    @click="drawer = true"
                  >
                    {{ $t("preconditionsHistory.filter") }}
                    <v-icon right dark>
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <!--Table-->
              <PreconditionOrdersHistoryTable
                :items="orders"
                :pageNo="pageNo"
                :pageSize="pageSize"
              />
              <v-col class="py-0 my-3" cols="12">
                <v-row justify="center">
                  <v-col class="py-0 text-center" cols="12">
                    <v-pagination
                      class="custom-number-pagination"
                      v-model="pageNo"
                      total-visible="6"
                      :length="totalPages"
                      @input="getHistoryOrder"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-skeleton-loader>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      width="500px"
      class="pa-5 gray9"
    >
      <!-- <v-text-field
        v-model="transactionTime"
        :placeholder="$t('preconditionsHistory.trxRangeDate')"
        name="fromDate"
        type="text"
        outlined
        hide-details
        id="transaction-time"
        background-color="var(--v-field-base)"
        clearable
        clear-icon="$closeIcon"
      /> -->
      <date-picker
        v-model="transactionTime"
        format="YYYY-DD-MM"
        :display-format="!userInfo.is_global ? 'jYYYY-jMM-jDD' : 'YYYY-DD-MM'"
        :locale="userInfo.is_global ? 'en' : 'fa'"
        :popover="$vuetify.rtl ? 'bottom-right' : 'bottom-left'"
        color="#500fe9"
        clearable
        range
      />
      <v-autocomplete
        v-model="formItem.symbol"
        :items="symbol"
        item-text="symbol"
        item-value="symbol"
        filled
        :placeholder="$t('preconditionsHistory.pairCoin')"
        :menu-props="{ bottom: true, offsetY: true }"
        class="mt-8"
        outlined
        :no-data-text="$t('common.nodata')"
      ></v-autocomplete>
      <v-select
        :items="orderTypes"
        :placeholder="$t('preconditionsHistory.orderType')"
        outlined
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="formItem.type"
      ></v-select>
      <v-select
        :items="directions"
        :placeholder="$t('preconditionsHistory.direction')"
        outlined
        item-text="title"
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="formItem.direction"
      ></v-select>
      <v-select
        :items="orderStatusList"
        :placeholder="$t('preconditionsHistory.status')"
        outlined
        item-text="locale"
        item-value="status"
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="formItem.status"
      ></v-select>
      <v-row>
        <v-col>
          <v-btn block text color="primary" @click="getHistoryOrder">
            {{ $t("preconditionsHistory.search") }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn block color="error" text @click="clearFilter">
            {{ $t("preconditionsHistory.clearFilters") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import PreconditionOrdersHistoryTable from "@/components/Market/historyOrders/PreconditionOrdersHistoryTable.vue";
// import dayjs from "dayjs";
import { ExchangeService, MarketMarketService } from "@/services";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    PreconditionOrdersHistoryTable
  },
  data() {
    return {
      drawer: false,
      transactionTime: "",
      symbol: [],
      orderTypes: [
        {
          value: "stop_limit",
          text: this.$t("preconditionsHistory.stopLimit")
        },
        {
          value: "oco",
          text: this.$t("preconditionsHistory.oco")
        }
      ],
      directions: [
        { title: this.$t("openOrders.buy"), value: 0 },
        { title: this.$t("openOrders.sell"), value: 1 }
      ],
      formItem: {
        symbol: "",
        type: "",
        source: "",
        direction: "",
        date: "",
        orderType: ""
      },
      orderStatusList: [],
      preconditionOrdersHistoryTableLoader: false,
      pageSize: 10,
      pageNo: 1,
      total: 10,
      totalPages: 0,
      loading: false,
      orders: []
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  mounted() {
    this.formItem.date = new Date().getTime();
    this.getHistoryOrder();
    this.getSymbol();
    this.getOrderStatusList();
  },
  methods: {
    getHistoryOrder() {
      this.loading = true;
      const { symbol, source, direction, status } = this.formItem;

      let startTime, endTime;
      if (this.transactionTime) {
        startTime = dayjs(this.transactionTime[0], "YYYY-DD-MM").valueOf();
        endTime = this.transactionTime[1]
          ? dayjs(this.transactionTime[1], "YYYY-DD-MM").valueOf()
          : null;
      }

      let payload = {
        symbol: symbol,
        direction: direction,
        source: source,
        startTime: startTime,
        endTime: endTime,
        status: status,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      Object.keys(payload).forEach(key => {
        if (payload[key] === "" || payload[key] === undefined) {
          delete payload[key];
        }
      });
      ExchangeService.getPreconditionOrdersHistoryList(payload)
        .then(response => {
          this.total = response.data.data.totalElements;
          this.totalPages = response.data.data.totalPages;
          this.orders = response.data.data.content;
          // let rows = [];
          // if (ordersHistoryData.length > 0) {
          //   this.total = response.data.data.totalElements;
          //   // for (let i = 0; i < ordersHistoryData.length; i++) {
          //   //   let row = ordersHistoryData[i];
          //   //   row.price =
          //   //     row.type === "MARKET_PRICE"
          //   //       ? this.$t("preconditionsHistory.marketPrice")
          //   //       : row.price;
          //   //   rows.push(row);
          //   // }
          //   this.orders = ordersHistoryData;
          // }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSymbol() {
      MarketMarketService.getSymbolsThumb().then(response => {
        if (response.data.length > 0) {
          this.symbol = response.data;
        }
      });
    },
    getOrderStatusList() {
      ExchangeService.getPreconditionOrderStatusList().then(response => {
        if (response.data.code === 0 && response.data.data.length > 0) {
          this.orderStatusList = response.data.data;
        }
      });
    },
    clearFilter() {
      this.transactionTime = "";
      this.formItem = {
        symbol: "",
        type: "",
        source: "",
        direction: "",
        date: "",
        orderType: ""
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
